import { Type } from 'class-transformer';
import { Arrays } from 'src/modules/utils/shared/arrays';
import { Comparable } from 'src/modules/utils/shared/comparable';
import { Objects } from 'src/modules/utils/shared/objects';
import { Strings } from 'src/modules/utils/shared/strings';

export class FrontendFieldListItem implements Comparable<FrontendFieldListItem> {

    static make<T>(items: T[], converter: (item: T) => [any, string, Partial<FrontendFieldListItem>?] = null, sort = true, frontElements?: [any, string, Partial<FrontendFieldListItem>?][]): FrontendFieldListItem[] {
        let result = items.map(item => {
            let converted = converter != null ? converter(item) : [item as any, Objects.toString(item), null];
            return new FrontendFieldListItem(converted[0], converted[1], converted[2]);
        });
        if (sort) {
            result = FrontendFieldListItem.sort(result);
        }
        if (frontElements != null) {
            result = [...frontElements.map(item => new FrontendFieldListItem(item[0], item[1], item[2])), ...result];
        }
        return result;
    }

    static flatten(paths: FrontendFieldListItem[][]): FrontendFieldListItem[] {
        let result: FrontendFieldListItem[] = [];

        for (let path of paths) {
            let current: FrontendFieldListItem = null;
            for (let item of path) {
                let found = current != null && current.children == null ? null : (current != null ? current.children : result).find(i => i.value == item.value);
                if (found == null) {
                    found = item;
                    if (current != null && current.children == null) {
                        current.children = [];
                    }
                    (current != null ? current.children : result).push(found);
                }
                current = found;
            }
        }
        return result;
    }

    static sort(items: FrontendFieldListItem[]): FrontendFieldListItem[] {
        for (let item of items) {
            if (item.children != null) {
                item.children = this.sort(item.children);
            }
        }
        return Arrays.sortBy(items, item => item.getComparable());
    }

    //Optionales HTML nur für den ausgewählten Eintrag; label bleibt der Klartext für Suche und Darstellung ohne Template.
    selectedLabelHtml: string;

    //netgen start
    label: string;
    value: any;
    internalObject: any;
    comparable: any;
    html = false;
    labelInDropdown: string;
    styleClass: string;
    icon: string;
    title: string;
    disabled = false;
    @Type(() => FrontendFieldListItem)
    children: FrontendFieldListItem[];
    //netgen end

    constructor(value: any, text: string, options: Partial<FrontendFieldListItem> = null) {
        this.assign(value, text, options);
    }

    assign(value: any, label: string, options: Partial<FrontendFieldListItem> = null): this {
        this.value = value;
        this.label = label;
        Object.assign(this, options);
        if (!this.html && (this.label?.includes("<") || this.label?.includes(">"))) {
            this.labelInDropdown = Strings.escapeHtml(this.label);
        }
        return this;
    }

    compareTo(other: FrontendFieldListItem): number {
        return this.getComparable().localeCompare(other.getComparable());
    }

    getComparable(): string {
        return this.comparable ?? this.label;
    }

}
